import React, { useState, useEffect } from 'react';
import { useEditor } from '../../contexts/EditorContext';

const EditableText = ({ 
  elementId, 
  pageId = 'home',
  children, 
  className = '', 
  as: Component = 'div',
  ...props 
}) => {
  const { isEditorMode, selectElement, pageContent } = useEditor();
  const [isHovered, setIsHovered] = useState(false);
  
  const savedContent = pageContent[pageId]?.[elementId];
  const displayContent = savedContent?.content?.text || children;

  const handleClick = (e) => {
    if (isEditorMode) {
      e.preventDefault();
      e.stopPropagation();
      selectElement(elementId, 'text', {
        text: displayContent,
        pageId
      });
    }
  };

  const editorStyles = isEditorMode ? {
    cursor: 'pointer',
    outline: isHovered ? '2px dashed #3B82F6' : 'none',
    outlineOffset: '4px',
    position: 'relative',
    transition: 'outline 0.2s'
  } : {};

  return (
    <Component
      className={className}
      onClick={handleClick}
      onMouseEnter={() => isEditorMode && setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={editorStyles}
      {...props}
    >
      {displayContent}
      {isEditorMode && isHovered && (
        <span className="absolute -top-6 left-0 bg-blue-600 text-white text-xs px-2 py-1 rounded">
          Klicken zum Bearbeiten
        </span>
      )}
    </Component>
  );
};

export default EditableText;
